import { Component, OnInit } from '@angular/core';
import { Utils } from 'src/app/common/utils';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AllPatient } from 'src/app/models/patient';
import { patientAppointment } from 'src/app/models/patientAppointment';
import moment from 'moment';
import { ExcelService } from 'src/app/service/excelDownload/excel.service';
import { CouponDetails } from 'src/app/models/CouponDetails';

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-superadmin-pat-detail',
  templateUrl: './superadmin-pat-detail.component.html',
  styleUrls: ['./superadmin-pat-detail.component.css']
})
export class SuperadminPatDetailComponent implements OnInit {
  public patAppointments: patientAppointment[] = [];
  public appointmentType: any;
  patdashCurrentTab: string = "personalInformation";
  pid: any;
  patient: AllPatient;
  patCouponDetails: CouponDetails[];
  allCouponDetails: CouponDetails[];
  patCouponForm: UntypedFormGroup;
  upcoming: boolean = true;
  pidMembers: number[] = [];

  constructor(private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private service: VproService,
    private utils: Utils,
    private location: Location,
    private excelService: ExcelService,
    private _formBuilder: UntypedFormBuilder
  ) {
    this.pid = this.route.snapshot.params["id"];
  }

  ngOnInit() {
    this.route.params.subscribe((routeParams) => {
      this.getPatientDetailsById();
    });
    this.patCouponForm = this._formBuilder.group({
      patCoupon: ['', [Validators.required]],
    });
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title:
        title
    });
  }

  patdashAssignTab(tabName: string): void {
    this.patdashCurrentTab = tabName;
    this.patCouponDetails = null;
    if (this.patdashCurrentTab === "appointments") {
      this.upcoming = true;
      this.getSuperadminPatientApt("upcoming");
    }
    else if (this.patdashCurrentTab === "discountCoupon") {
      this.fetchAllCoupons();
      this.fetchPatientCoupons();
    }
  }

  getPatientDetailsById() {
    this.spinner.show();
    this.service.getPatientById(this.pid, '?fields=members')
      .subscribe(res => {
        this.spinner.hide();
        this.patient = res;
        if (this.patient) {
          this.patient.members.forEach(element => {
            this.pidMembers.push(element.pid);
          });
        }
      }, error => {
        console.log(error);
        this.spinner.hide();
        this.showToast('error', "Someting went wrong!");
      })
  }

  getSuperadminPatientApt(type) {
    let data = {
      //pid: this.pid,
      pid: this.pidMembers,
      type: type,
    };
    this.appointmentType = type;
    this.patAppointments = null;
    this.spinner.show();
    this.service.getPatientAppointmentsSuperadmin(data).subscribe(res => {
      this.spinner.hide();
      this.patAppointments = res;
      if (this.patAppointments) {
        if (this.patAppointments.length > 0) {
          this.patAppointments.forEach((aptime) => {
            if (aptime) aptime.aptime = Utils.formatTime(aptime.aptime);
          });
        }
      }
    }, err => {
      console.log(err);
      this.spinner.hide();
      this.showToast('error', "No Appointments Found");
    })

  }


  addCoupon() {
    let data = { pid: this.pid };
    this.spinner.show();
    this.service.addCoupons(this.patCouponForm.get("patCoupon").value.id, data).subscribe(res => {
      this.spinner.hide();
      this.showToast('success', "Coupon addeded successfully");
      this.fetchPatientCoupons();
      this.fetchAllCoupons();
    }, err => {
      console.log(err);
      this.spinner.hide();
      this.showToast('error', "Coupon could not be added");
    });

  }

  removeCoupon(index) {
    this.spinner.show();
    this.service.deletePatientCoupon(this.patCouponDetails[index].id, this.pid).subscribe(res => {
      this.spinner.hide();
      this.showToast('success', "Coupon removed successfully");
      this.fetchPatientCoupons();
      this.fetchAllCoupons();
    }, err => {
      console.log(err);
      this.spinner.hide();
      this.showToast('error', "Could not remove Coupon");
    })
  }

  fetchAllCoupons() {
    this.spinner.show();
    this.service.fetchCoupons("?active=true").subscribe(res => {
      this.spinner.hide();
      this.allCouponDetails = res;
    }, err => {
      console.log(err);
      this.spinner.hide();
      this.showToast('error', "No Coupons Added");
    })
  }

  fetchPatientCoupons() {
    this.spinner.show();
    this.service.fetchCoupons(`?pid=${this.pid}`).subscribe(res => {
      this.spinner.hide();
      this.patCouponDetails = res;
    }, err => {
      console.log(err);
      this.spinner.hide();
      this.showToast('error', "No Coupons Added");
    })
  }

  expiryCheck(index) {
    let validTo = moment.utc(this.patCouponDetails[index].valid_to);
    return validTo.isBefore(moment().utc());
  }

  exportAsXLSX() {
    let excelPatApts: any = [];
    let excelFileName: string = "";
    let excelSheetName: string = "";
    let personalInfo: any = [];

    if (this.patAppointments) {
      if (this.upcoming) {
        excelFileName = (this.patient.first_name + " " + this.patient.last_name) + "_" + this.patient.pid.toString() + "_UpcomingAppointments";
        excelSheetName = "UpcomingAppointments";
      }
      else if(this.appointmentType == 'past'){
        excelFileName = (this.patient.first_name + " " + this.patient.last_name) + "_" + this.patient.pid.toString() + "_PastAppointments";
        excelSheetName = "PastAppointments";
      }
      else if(this.appointmentType == 'all'){
        excelFileName = (this.patient.first_name + " " + this.patient.last_name) + "_" + this.patient.pid.toString() + "_AllAppointments";
        excelSheetName = "AllAppointment";
      }


      if (this.patient) {
        personalInfo.push({
          "NAME": this.patient.first_name + " " + this.patient.last_name,
          "D.O.B": this.patient.dob === null ? "Not Available" : moment(this.patient.dob, 'YYYY-MM-DD').format('DD-MMM-YYYY'),
          "GENDER": this.patient.gender === null ? "Not Available" : this.patient.gender,
          "EMAIL ID": this.patient.email_id === null ? "Not Available" : this.patient.email_id,
          "CONTACT NO": this.patient.contact_no === null ? "Not Available" : this.patient.contact_no
        });
      }

      this.patAppointments.forEach(element => {

        excelPatApts.push({
          "APT ID": element.aptid === null ? "Not Available" : element.aptid,
          "APT DATE": element.apdate === null ? "Not Available" : moment(element.apdate, 'YYYY-MM-DD').format('DD-MMM-YYYY'),
          "APT TIME": element.aptime === null ? "Not Available" : element.aptime,
          "PATIENT NAME": ((element.patfirstname === null ? "" : element.patfirstname) + " " + (element.patlastname === null ? "" : element.patlastname)),
          "PHYSICIAN NAME": ((element.phyfirstname === null ? "" : element.phyfirstname) + " " + (element.phylastname === null ? "" : element.phylastname)),
          "APT TYPE": element.apttype === null ? "Not Available" : element.apttype.replace('_', ' ').toUpperCase(),
          "STATUS": element.schedule_stat === null ? "Not Available" : element.schedule_stat.replace('_', ' ').toUpperCase()
        });
      });
      this.excelService.exportAsExcelFile(personalInfo, excelPatApts, excelFileName, excelSheetName);
    }

  }

  getback() {
    this.location.back();
  }

}
